/**
 * Accessible name of the navigation logo (`aria-label`).
 * The nested logo img is decorative. Work status has its own header indicator.
 */
export const PROJECT_LOADING_STATUS_NAME = 'Nodon';

export const APP_WORK_STATUS_NAME = 'App work';
